module.exports = __webpack_public_path__ + "img/afghanistan_icc.11c3c45e.png";